import api from '@/services/Api';

export default {
    getSpecialTasksList(){
        return api.get('/api/v1/special-tasks')
    },
    getSpecialTask(slug){
        return api.get('/api/v1/special-tasks/'+slug)
    },
    getSpecialTaskSummary(slug, place){
        return api.get(place ? '/api/v1/special-tasks/'+slug+'/summary?customerNumber=' + place : '/api/v1/special-tasks/'+slug+'/summary')
    }
}